import React, { useState } from "react";
import API from "../api";
import { FaStore } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";

import "../css/style.css";

const AdminLogin = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        email: "",
        password: ""
    });

    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (submitting) return;

        setSubmitting(true);

        try {
            const res = await API.post("/admin/login", form);

            toast.success(res.data.message || "Login successful");

            // save admin
            localStorage.setItem("admin", JSON.stringify(res.data.admin));
            localStorage.setItem("token", res.data.token);

            setTimeout(() => {
                navigate("/dashboard");
            }, 1500);

        } catch (err) {

            const msg = err.response?.data?.message;

            // If admin not exists → inform user (setup page is disabled)
            if (msg === "Admin not found") {
                toast.error("No admin found! Please run the seed script (`npm run seed:admin`) or contact admin.");
            } else {
                toast.error(msg || "Login failed");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="login-container">

            <div className="login-box">

                <div className="login-brand">
                    <div className="login-brand-badge">
                        <FaStore />
                    </div>
                    <div>
                        <h2>POS System</h2>
                        <p className="login-subtitle">Sign in to your business dashboard</p>
                    </div>
                </div>

                <form onSubmit={handleLogin} noValidate>

                    <div className="login-field">
                        <label htmlFor="login-email">Email address</label>
                        <input
                            id="login-email"
                            type="email"
                            name="email"
                            placeholder="admin@company.com"
                            value={form.email}
                            onChange={handleChange}
                            autoComplete="email"
                            required
                        />
                    </div>

                    <div className="login-field">
                        <label htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            value={form.password}
                            onChange={handleChange}
                            autoComplete="current-password"
                            required
                        />
                    </div>

                    <button type="submit" className="login-submit" disabled={submitting}>
                        {submitting ? "Signing in…" : "Sign In"}
                    </button>

                </form>
            </div>

            {/* Toast */}
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default AdminLogin;